import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  IzlazneFaktureClient,
  OtpremnicaDto,
  OtpremniceClient,
  PredracunDto,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OtpremnicaDuplikatResolver
  extends BaseService
  implements Resolve<OtpremnicaDto> {
  constructor(private _client: OtpremniceClient, private _router: Router) {
    super();
  }

  resolve():
    | Observable<OtpremnicaDto>
    | Promise<OtpremnicaDto>
    | OtpremnicaDto
    | null {
    let id = 0;
    try {
      id = this._router.getCurrentNavigation().extras.state.id;
    } catch {
      return null;
    }

    return this._client.duplicateOtpremnica(id).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {})
    );
  }
}
